<div class="search-box">
    <fa-icon [icon]="faSearch"></fa-icon>
    <input
        class="form-control"
        type="text"
        placeholder="Search"
        (ngModelChange)="modelChangeFn($event)"
        [(ngModel)]="search"
        name="search"
    />
</div>
